import { ArrowRight, Briefcase, Building2, CalendarDays, MapPin, PackageOpen, Sparkles } from "lucide-react";
import { COMPANY, PHOTOS } from "@/lib/site";

export const CompanyProfile = () => {
  return (
    <section id="profil" data-testid="company-profile-section" className="company-profile-section company-profile-modern relative overflow-hidden">
      <div className="company-profile-decor company-profile-decor--top" aria-hidden="true" />
      <div className="company-profile-decor company-profile-decor--bottom" aria-hidden="true" />

      <div className="max-w-7xl mx-auto px-5 sm:px-6 relative z-10">
        <div className="company-profile-modern__hero">
          <div className="company-profile-modern__copy">
            <div className="company-profile-modern__eyebrow">Profil Perusahaan</div>
            <h1 className="company-profile-modern__title">PT Animax Putra Lancar</h1>
            <p className="company-profile-modern__lead">
              <strong>Didirikan sejak tahun 2021, PT. Animax Putra Lancar</strong> merupakan perusahaan
              trading yang berfokus pada penyediaan material dan produk berkualitas untuk kebutuhan
              proyek, retail, display, interior, serta industri.
            </p>
            <p className="company-profile-modern__body">
              Berlokasi di Mojokerto, Jawa Timur, kami menghadirkan solusi produk yang berkualitas
              dengan pelayanan profesional kepada pelanggan di seluruh Indonesia. Seiring berkembangnya
              perusahaan, kami terus memperluas lini produk—dari <strong>ANIMAX Acrylic</strong> hingga
              elektronik, kitchen equipment, dan kebutuhan industri lainnya.
            </p>

            <div className="company-profile-modern__actions">
              <a href="/#produk" className="company-profile-modern__button">
                Jelajahi lini produk <ArrowRight className="w-4 h-4" />
              </a>
              <a href="#keunggulan" className="company-profile-modern__text-link">
                Kenapa memilih kami <ArrowRight className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div className="company-profile-modern__visual-wrap">
            <div className="company-profile-modern__visual">
              <img src={PHOTOS.kantorDisplay} alt="Display kantor PT Animax Putra Lancar" />
              <div className="company-profile-modern__visual-shade" />
              <div className="company-profile-modern__visual-label">
                <span className="tag-uppercase">PT. Animax Putra Lancar</span>
                <strong>Solusi lintas<br />kebutuhan.</strong>
              </div>
              <div className="company-profile-modern__visual-badge">
                <Sparkles className="w-4 h-4" />
                <span>Trusted material partner</span>
              </div>
            </div>
            <div className="company-profile-modern__floating-card">
              <PackageOpen className="w-5 h-5 text-[#e60012]" />
              <div><strong>04</strong><span>Lini produk</span></div>
            </div>
          </div>
        </div>

        <div className="company-profile-modern__facts">
          <div data-testid="profile-fact-0"><CalendarDays /><span>Didirikan</span><strong>Tahun 2021</strong></div>
          <div data-testid="profile-fact-1"><Briefcase /><span>Bidang usaha</span><strong>Trading company</strong></div>
          <div data-testid="profile-fact-2"><MapPin /><span>Jangkauan</span><strong>Seluruh Indonesia</strong></div>
          <div className="company-profile-modern__address"><Building2 /><span>{COMPANY.address}</span></div>
        </div>
      </div>
    </section>
  );
};
